export default function HalfTriangleMosaic() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 1000 1000" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2413_1798)">
                <rect width="100%" height="100%" fill="white" />
                <path d="M1000 0H0V1000L1000 0Z" fill="#FF89C2" />
                <path d="M1000 0L500 500L1000 1000V0Z" fill="#01B4EE" />
                <path d="M1000 1000L500 500L0 1000H1000Z" fill="#1C5DCC" />
            </g>
            <defs>
                <clipPath id="clip0_2413_1798">
                    <rect width="100%" height="100%" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}